import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function useScrollToSection() {
  const location = useLocation();

  useEffect(() => {
    const scrollTo = new URLSearchParams(location.search).get("scrollTo");

    if (scrollTo) {
      // Delay to ensure DOM is loaded
      const timeout = setTimeout(() => {
        const element = document.getElementById(scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);

      return () => clearTimeout(timeout);
    }
  }, [location]);
}

export default useScrollToSection;